import { IconProp } from "@fortawesome/fontawesome-svg-core";

export type RepositoryApiSubTypes = "MBL" | "API" | 'SOAP' | 'RECV' | 'FSOL'
export type ArtifactMobileApiTypes = "SDK" | "DOC"
export type CatalogKeyType = 'BASE' | 'AFO' | 'REPO' | 'ART' | 'GSOAP' | 'HLPDC'
export type GenericCatalogKeyType = 'usrDataPart' | 'ticketModuloOp'

export type CodeSendType = 0 | 1 | 2

export type CodeStatusType = 0 | 1 | 2

export type ApiCatalogRoot = {
    [K in CatalogKeyType]: ApiCatalog[]
}

export type ApiCatalogGeneric = {
    usrDataPart: ApiUsrDataPartCatalog[],
    ticketModuloOp: ApiDashboardCatalog[],
    ticketProcesoOp: ApiDashboardCatalog[]
}

export interface ApiBasicResponse {
    codigo: number,
    mensaje: string
}

export interface ApiGenericResponse<Output> extends ApiBasicResponse {
    datos: Output,
    operacionExitosa: boolean,
    secured: boolean
}

export interface ApiLoginAuth {
    "username": string,
    "password": string,
    "clientID": string
}

export interface ApiLoginAuthResponse {
    "token": string,
    "sesionActiva": number
}

export interface ApiPortalAccessMenu {
    "id": number,
    "idPadre"?: number,
    "nombre": string,
    "ruta": string,
    "icono"?: IconProp,
    "activo"?: number,
    "descripcion"?: string,
    "submenus"?: ApiPortalAccessMenu[]
}

export interface ApiPortalUserDataPart {
    "id": number,
    "clave": string,
    "etiqueta": string,
    "valor": string,
    "orden": number,
    "icono"?: string,
}

export interface ApiPortalUserBase {
    "id": number,
    "rol": number,
    "nombre": string,
    "datosParticulares"?: ApiPortalUserDataPart[]
}

export interface ApiPortalAccessRol {
    "id": number,
    "nombre": string,
    "totalUsuarios": number,
    "descripcion": string,
    "menu": ApiPortalAccessMenu[]
}

export interface ApiPortalNotifications {
    "id": number,
    "contenido": string,
    "origen": string,
    "estatus": 0 | 1,
    "fechaControl": string
}

export interface ApiBaseRepository {
    "id": number,
    "nombre": string,
    "recursos"?: ApiResource[]
}

export interface ApiRepository extends ApiBaseRepository {
    "idWorkspace"?: number,
    "subtipo": RepositoryApiSubTypes,
    "rutaRepositorio": string,
    "descripcion": string,
}

export interface ApiCredentialsInput {
    "workspace": string,
    "descripcion": string,
    "acceso": string,
    "credencial": string,
    "uriRedirrecion"?: string,
    "codigo"?: string | null,
}

export interface ApiCredentials extends ApiCredentialsInput {
    "id": number,
    "credencial": string,
    "token": string,
    "fechaControl": string,
    "usuarioModificador": string,
    "repositorios": ApiRepository[]
}


export interface ApiJiraProject {
    idTercero: string,
    nombre: string,
    key: string,
    avatar: string,
    tipo: string
}


export interface ApiPinnedDashboard extends ApiJiraProject {
    id: number,
    idCredencial: number,
    descripcion: string,
    "fechaControl"?: string,
    "usuarioModificador"?: string,
}

export interface ApiJiraCredentials extends ApiCredentialsInput {
    "id": number,
    "workspaceId": string,
    "token": string,
    "fechaControl": string,
    "usuarioModificador": string,
    "tableros": ApiPinnedDashboard[]
}

export interface ApiJiraTicketType {
    id: string;
    descripcion: string;
    nombre: string;
}

export interface ApiJiraIssue {
    resumen: string,
    idProyecto: string,
    label?: string,
    descripcion: string
}

export interface ApiJiraComment {
    id: string;
    text: string[];
    media: ApiResourceVersionArtifact[];
    autor: string;
    creado: string;
    actualizado: string;
}

export interface ApiJiraIssueItem extends ApiJiraIssue {
    id: string,
    key: string,
    creado?: string,
    actualizado?: string,
    estatus?: {
        id?: string,
        color?: string,
        label?: string
    },
    adjuntos?: ApiResourceVersionArtifact[],
    comentarios?: ApiJiraComment[]
}

export interface ApijiraTicketWorkflowStatus {
    id: string;
    referencia: string;
    nombre: string;
    categoria: string;
    issues: ApiJiraIssueItem[]
}

export interface ApijiraTicketWorkflowTransitions {
    id: string;
    tipo: string;
    referencia: string;
    nombre: string;
    descripcion: string;
}

export interface ApiJiraTicketWorkflowData {
    id: string,
    statues: ApijiraTicketWorkflowStatus[],
    transiciones: ApijiraTicketWorkflowTransitions[]
}

export interface ApiResourceName {
    "nombre": string
}

export interface ApiResourceSubtype {
    "id": string
}

export interface ApiNotificationsItemtype {
    "elementos": number
}

export interface ApiUpdateRolResources {
    "idRol": number,
    "recursos": { idRecurso: number, idMenu: number }[]
}

export interface ApiDocumentationHeaderSubtype {
    "id": string,
    "comentarios": boolean
}

export interface ApiResourceVersionArtifact {
    "id": number,
    "nombre": string,
    "tipoArtefacto": string,
    "rutaArtefacto"?: string
    "fechaControl"?: string
}

export interface ApiResourceVersionBase {
    "id": number,
    "version": string,
    "nota": string,
    "fechaCreacion"?: string
}

export interface ApiResourceVersion extends ApiResourceVersionBase {
    "afores": string,
    "normativo": number,
    "fechaControl"?: string,
    "artefactos": ApiResourceVersionArtifact[]
}

export interface ApiResource {
    "id": number,
    "idRepositorio": number,
    "etiqueta": string,
    "nombre": string,
    "descripcion"?: string,
    "fechaCreacion"?: string,
    "fechaControl"?: string,
    "versiones": ApiResourceVersion[],
    "ultimaVersion"?: ApiResourceVersionBase
    "menuAsociado"?: number[],
    "aforeGeneral"?: string,
    "comentariosAsociados"?: number
}

export interface ApiArtifactDownload {
    "idRepositorio": number,
    "idArtefacto": number
}

export interface ApiDocumentationComment {
    id: number,
    idPagina?: number,
    idPadre?: number,
    contenido: string,
    usuario?: string,
    version: number,
    actualizacion?: string,
    tituloPrincipal?: string,
    usuarioComentarioPadre?: string,
    comentarios: ApiDocumentationComment[],
    origen?: string
}

export interface ApiDocumentationPage {
    contenido: string
    version: number,
    actualizacion: string,
    comentarios: ApiDocumentationComment[]
}

export interface ApiCatalog {
    codigo: string
    valor: string
    activo: 0 | 1
    operativo?: 0 | 1,
    tipo?: string
}

export interface ApiUsrDataPartCatalog {
    clave: string,
    mapeo: string,
    descripcion: string,
    icono: string,
    orden: number,
    activo: number
}

export interface ApiDashboardCatalog {
    id: number;
    nombre: string;
    descripcion: string;
    activo: number,
    fechaControl?: string;
    usuarioModificador?: string;
}

export interface ApiBlogEntry {
    id: number,
    url: string,
    autor: string,
    titulo: string,
    sinopsis: string,
    keywords: string,
    comentariosHabilitados: boolean,
    indiceHabilitado: boolean,
    fechaControl?: string
}

export interface ApiPortalAccess extends ApiPortalUserBase {
    "notificacionesPendientes": number,
    "afore": string,
    "menu": ApiPortalAccessMenu[],
    "credenciales"?: ApiCredentials[],
    "credencialesTableros"?: ApiJiraCredentials[],
    "catalogosApp": ApiCatalogRoot,
    "sdk": ApiBaseRepository[],
    "soap": ApiBaseRepository[],
    "rest"?: ApiBaseRepository[],
    "recursosVinculados": ApiResource[],
    "roles"?: ApiPortalAccessRol[],
    "catalogosGenericos": ApiCatalogGeneric
}

export interface ApiResourceDocComment {
    "recurso": ApiResource,
    "comentarioAsociado": ApiDocumentationComment
}

export interface ApiLogbookRequest {
    numeroDias: number;
    curp: string;
}

export interface ApiLogbookSartokenRequest extends ApiLogbookRequest {
    afore: string;
    idServicio: number;
}

export interface ApiServiceItem {
    id: number;
    nombre: string;
    descripcion: string;
}

export interface ApiSartokenCodSegLogbook {
    idCodigo: number;
    codigo: string;
    idAplicacion: number;
    fechaGeneracion: string;
    fechaControl: string;
    "estatus": CodeStatusType,
    "tipoEnvio": CodeSendType,
    celular: string;
    email: string;
}

export interface ApiSartokenServiceLogbookDevice {
    nombre: string;
    modelo: string;
    uuid: string;
    os: string;
    georeferencia: string;
    appVersion: string;
    sdkVersion: string;
}

export interface ApiSartokenServiceLogbook {
    curp: string;
    idBitacora: number;
    servicioId: number;
    servicioNombre: string;
    respMensaje: string;
    respExcepcion: string;
    identidadCliente: string;
    identidadProyecto: string;
    fecha: string;
    dispositivo: ApiSartokenServiceLogbookDevice;
}

export interface ApiSartokenServiceLogbookDetail {
    request: string;
    response: string;
    stackTrace: string;
}

export interface ApiSartokenRequest<T> {
    "identity": {
        "client-id": string,
        "client-secret": "s7M3gWtNw7hJklN6",
        "project-id": "mx.com.procesar.aforeweb"
    },
    "device": {
        "appVersion": "2.20",
        "date-time": string,
        "geo-location": string,
        "language": "es-MX",
        "model": string,
        "name": string,
        "os": "Web",
        "sdkVersion": "1.0.0",
        "uuid": "AforeWeb"
    },
    "input": T
}

export interface ApiSartokenCurpRequest {
    "curp": string
}

export interface InputCatalogueType {
    "nombre-catalogo": "entidad-federativa"
}

export interface ApiSartokenCatalogueData {
    id: string,
    nombre: string,
}

export interface ApiSartokenCatalogueDataset<T> extends ApiSartokenCatalogueData {
    campos: T
}

export interface ApiSartokenCatFieldFederalState {
    "clave": string,
    "claveAlfabetica": string,
    "idPais": number,
    "nombrePais": string
}

export interface ApiSartokenCatalogue<T> {
    "dataSet": ApiSartokenCatalogueDataset<T>[],
    "page-number": string,
    "total-pages": string,
    "total-records": string | null
}

export interface ApiSartokenResponse<T> {
    "code": string,
    "exception": string | null,
    "message": string,
    "output": T
    "cve-diagnostico": string,
    "date-time": string,
    "exec-time": number,
    "stack-trace": string | null
}


export interface ApiValidarCurpResponse {
    "nombre": string,
    "sexo": "H" | "M",
    "apellido-materno": string,
    "apellido-paterno": string,
    "clave-entidad": string,
    "clave-nacionalidad": string,
    "descripcion-entidad": string,
    "descripcion-nacionalidad": string,
    "fecha-nacimiento": string
}



export interface ApiSarenvProfile {
    nombre?: string;
    apellidoPaterno?: string;
    apellidoMaterno?: string;
    fechaNacimiento: string;
    curp?: string;
    cvEntNac?: string;
    cvNacion?: string;
    sexo?: string;
    tipoAmbientacion?: string,
    nss?: string
    cvAfore?: string,
    nombreImss?: string,
    email?: string,
    celular?: string
}

export const apiSarenvRelevantFields = ['nip']
export type ApiSarenvRelevantFields = typeof apiSarenvRelevantFields[number];
export type ApiSaenvProfileRespRelevantFields = {
    [T in ApiSarenvRelevantFields]?: string
}

export interface ApiSaenvProfileResp extends ApiSarenvProfile, ApiSaenvProfileRespRelevantFields {
    "hashNip"?: string,
    "folio"?: string,
    "idProcesar"?: string,
    "resultadoOperacion"?: string
}

export interface ApiAmbientestLogbookRequest {
    usuario?: string;
    curp?: string;
}

export interface ApiAmbientestLogbookRecordRequest {
    id: number
    curp: string;
    mensaje: string;
    usuario: string;
    tipoSolicitud: string;
    estatus: number;
    fechaSolicitud: string;
}


export interface ApiUserPushSubscribe {
    idUsuario: number;
    token: string;
    navegador: string;
}